"use strict";
(self["webpackChunkapp"] = self["webpackChunkapp"] || []).push([["apps_app_src_app_personal-number_i18n_personal-number_sv_json"],{

/***/ 5433:
/***/ ((module) => {

module.exports = JSON.parse('{"heading":"Saknar personnummer","missingPersonalNumber":"Du saknar personnummer på din användare.","addressPersonalNumber":"Du måste korrigera uppgifterna för att kunna gå vidare.","noSwedishPnr":"Jag saknar personnummer","error":"Ett fel har inträffat, vänligen kontrollera dina uppgifter och försök igen.","invalidPnr":"Ogiltigt personnummer. Vänligen ange personnummer i formatet ÅÅMMDD-XXXX.","personalNumber":"{{global.personalNumber}}*","accept":"Spara","cancel":"Logga ut"}');

/***/ })

}]);